import Vue from 'vue'
import * as toastr from 'toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'

if ($('#warehouseshift_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#warehouseshift_form',
    components: {
      RingLoader,
      TextInput,
      NumberInput,
      Singleselect,
      Multiselect,
      datePicker,
      moment
    },
    mixins: [mixins],
    data: {
      loading: 0,
      mealTitle: null,
      form: {
        entity: {
          moveType: null,
          objectType: 'product',
          status: 'expected',
          unit: '',
          unitPrice: null,
          dateExpected: moment().locale('pl').format('YYYY-MM-DD HH:mm'),
          dateFinal: null,
          materialReleaseReceipt: null
        },
        options: {
          movementTypes: [],
          objectTypes: [],
          statuses: [],
          objects: [],
          units: [],
          warehouses: [],
          users: [],
          meals: [],
          errors: {},
        },
      },
      entityId: null,
      currentObject: null,
    },
    watch: {
      'form.entity.objectId': function () {
        if (!this.loading) {
          this.refreshUnitPrice()
        }
      },
    },
    mounted: function () {
      this.loading++

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getWarehouseShift()
      }

      this.mealTitle = this.form.entity.moveType === 'move_return' ?
        Translator.trans('warehouse_shift.entity.return_meal') :
        Translator.trans('warehouse_shift.entity.meal')

      this.getMovementTypes()
      this.getObjectTypes()
      this.getStatuses()
      this.getUnits()
      this.getWarehouses()
      this.getUsers()
      this.getMeals()
      this.getObjects()

      this.loading--
    },
    methods: {
      changeObjectType(event) {
        this.form.entity.objectType = event.$event
        this.form.entity.objectId = null
        this.form.entity.unit = null
        this.form.entity.unitWeight = null
        this.getObjects()
      },
      getWarehouseShift() {
        this.loading++
        let url = Routing.generate('api_get_warehouse_shift', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          this.getObjects()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      updateWarehouseShift(redirect) {
        this.loading++

        let url = Routing.generate('api_patch_warehouse_shift', {
          id: this.entityId,
        })

        let data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('warehouse_shift_grid'))
          } else {
            toastr.success(Translator.trans('warehouse_shift.update.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      createWarehouseShift(redirect) {
        let url = Routing.generate('api_post_warehouse_shift')

        let data = { data: this.form.entity }
        this.loading++

        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('warehouse_shift_grid'))
          } else {
            toastr.success(Translator.trans('warehouse_shift.create.created'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      /**
       * get all available movement types(types) from server
       */
      getMovementTypes() {
        let url = Routing.generate('api_get_warehouse_shifts_movement_type')
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.movementTypes = response.data

          if (this.form.entity.moveType === null && response.data.length) {
            this.form.entity.moveType = response.data[0]
          }

          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      /**
       * get all available object types from server
       */
      getObjectTypes() {
        this.loading++
        this.$http.get(Routing.generate('api_get_warehouse_shifts_object_type')).then(response => {
          this.form.options.objectTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      /**
       * get all available statuses from server
       */
      getStatuses() {
        let url = Routing.generate('api_get_warehouse_shifts_status')
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.statuses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      /**
       * get all available objects for specified type from server
       */
      getObjects() {
        // if there is no object type(not selected) then don't need to do this action
        if (!this.form.entity.objectType) {
          return
        }

        let url = Routing.generate('api_get_warehouse_shifts_available_objects_by_type', {
          type: this.form.entity.objectType,
          context: 'dropdown'
        })

        // set current chose in list to null(can be old chose from previous list)
        this.form.options.objectId = null

        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.objects = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      /**
       * get all available units from server
       */
      getUnits() {
        let url = Routing.generate('api_get_products_units')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.units = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      /**
       * get all warehouses users from server
       */
      getWarehouses() {
        let url = Routing.generate('api_get_warehouses', { context: 'dropdown' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.warehouses = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      /**
       * get all available users from server
       */
      getUsers() {
        let url = Routing.generate('api_get_employees', { context: 'dropdown' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.users = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      /**
       * then object id is changed then it's neccesary to refresh unit(take it from object or set it to default)
       * @param event
       */
      changeObjectId(event) {
        let objectObject = event.$event
        if (typeof objectObject !== 'object') {
          return
        }

        this.currentObject = objectObject

        // take unit from product object
        let unit = objectObject.unit || null
        let weight = objectObject.unitWeight || null

        // if unit is in list then set it, in other way set it to piece
        this.form.entity.unit = ['kg', 'piece'].indexOf(unit) >= 0 ? unit : 'piece'
        this.form.entity.unitWeight = weight ? weight : 1
      },
      /**
       * Get all available meals
       */
      getMeals() {
        let url = Routing.generate('api_get_meals_by_kind', { kind: 'final_meal',
          context: 'dropdown' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.meals = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      /**
       * Then movement type is changed
       */
      changeMovementType() {
        // if movement type is "out" then delete all values from warehouseTo and userTo fields
        if (this.form.entity.moveType === 'out') {

          this.form.entity.warehouseTo = null
          this.form.entity.userTo = null
        }

        this.mealTitle = this.form.entity.moveType === 'move_return' ?
          Translator.trans('warehouse_shift.entity.return_meal') :
          Translator.trans('warehouse_shift.entity.meal')
      },
      /**
             * then status is changed - if new status is expected then clear amountFinal value
             * @param event
             */
      statusChange(event) {
        if (event.$event === 'expected') {
          this.form.entity.amountFinal = null
        }
      },
      /**
             * When unit is changed then check if it's kg, then always set unit weight to 1, if unit is piece, then
             * let grabbed weight of piece
             * @param event
             */
      unitChange(event) {
        let unit = event.$event

        if (unit === 'kg') {
          this.form.entity.unitWeight = 1
        } else {
          this.form.entity.unitWeight = this.currentObject.weight ? this.currentObject.weight : 1
        }
      },
      updateUnitPrice(e) {
        this.form.entity.unitPrice = parseFloat(e.target.value).toFixed(2)
      },
      refreshUnitPrice() {
        if (this.form.entity.objectType === 'product' && this.form.entity.objectId) {
          Vue.http.get(
            Routing.generate('api_get_warehouse_shift_latest_product_move_in_unit_price', { product: this.form.entity.objectId })
          ).then(response => {
            this.form.entity.unitPrice = response.data.unit_price
          })
        }
      },
      /**
       * Get name of object from id and return it as id and name
       * @param obj
       */
      translateObjectId(obj) {
        if (obj !== null && obj.id && obj.name) {
          return `#${obj.id} ${obj.name}`
        }
        return ''
      },
      /**
       * Get serving object and return it as user friendly string
       * @param obj
       * @returns {*}
       */
      translateServing(obj) {
        if (obj === null || !obj.id || !obj.name || !obj.type) {
          return ''
        }

        let prefixes = {
          'component': Translator.trans('warehouse_shift.serving_types.component'),
          'final': Translator.trans('warehouse_shift.serving_types.final'),
        }
        let prefix = prefixes[obj.type]
        return `#${obj.id} ${prefix} ${obj.name}`
      },
      translateMovementType(name) {
        return Translator.trans(`warehouse_shift.entity.movement_types.${name}`)
      },
      translateObjectType(name) {
        return Translator.trans(`warehouse_shift.entity.object_types.${name}`)
      },
      translateStatus(name) {
        return Translator.trans(`warehouse_shift.entity.statuses.${name}`)
      },
      translateUnit(name) {
        return Translator.trans(`warehouse_shift.entity.units.${name}`)
      },
    }
  })
}
